import { useTranslation } from 'react-i18next';
import ConfirmDialog from '../../components/ConfirmDialog';

export default function ResetPasswordConfirmModal({ onClose, onSubmit }) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open
      onClose={onClose}
      title={t('lease.password.resetTitle')}
      body={t('lease.password.resetDescription')}
      cancelLabel={t('common.cancel')}
      confirmLabel={t('lease.password.resetPassword')}
      onConfirm={onSubmit}
    />
  );
}
